module.exports = __webpack_public_path__ + "img/icon-comments.b615ba02.svg";